import formsSelect from "./forms/_select.js";
import otherHeadAlert from "./others/_head-alert.js";
import buttonsFavorite from "./buttons/_favorite.js";
import buttonsShare from "./buttons/_share.js";
import basicsBadge from './basics/_badge.js';
import othersSearchMenu from "./others/_search-menu.js";
import othersSearchList from "./others/_search-list.js";
//import cardsEstate from "./cards/_estate.js";
import othersSelectSite from "./others/_select-site.js";
import othersSelectSearch from "./others/_select-search.js";
import hamburger from "./others/_hamburger.js";
import megaMenu from "./others/_mega-menu.js";
const components = () => {
    formsSelect();
    otherHeadAlert();
    buttonsFavorite();
    buttonsShare();
    basicsBadge();
    othersSearchMenu();
    othersSearchList();
    //cardsEstate();
    othersSelectSite();
    othersSelectSearch();
    hamburger();
    megaMenu();
}

export default components;
